import { KeyRounded } from '@mui/icons-material';
import { Avatar, Box, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setSelectedItem } from 'app/actions/token';
import { Autosizer, Scrollbar } from 'app/components';
import { selectedItemTokenSelector, sortItemsTokenSelector } from 'app/selectors/token';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';

const TokenList = function () {
  const dispatch = useDispatch();
  const selectedItem = useSelector(selectedItemTokenSelector);
  const sortItems = useSelector(sortItemsTokenSelector);

  const handleItemClick = (value) => dispatch(setSelectedItem(value));

  return (
    <Box
      component='div'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        padding: theme.spacing(0),
        '.MuiListItem-root': {
          width: '100%',
          userSelect: 'none',
          padding: theme.spacing(0),
          borderRadius: '0',
          '.MuiListItemAvatar-root': {
            minWidth: '36px',
          },
          '.MuiAvatar-circular': {
            width: '24px',
            height: '24px',
            color: theme.palette.primary.main,
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            svg: {
              fontSize: '16px',
            },
          },
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            borderRadius: '0',
          },
          '.MuiListItemText-root': {
            margin: theme.spacing(0),
          },
        },
      })}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => {
                return (
                  <FixedSizeList
                    height={height}
                    itemSize={36}
                    itemCount={sortItems.length}
                    innerRef={contentNodeRef}
                    outerRef={scrollableNodeRef}
                    innerElementType={tokenListInnerElementType}
                    itemData={{
                      items: sortItems,
                      selectedItem,
                      onClick: handleItemClick,
                    }}>
                    {tokenListItemRender}
                  </FixedSizeList>
                );
              }}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const tokenListInnerElementType = forwardRef((props, ref) => <List ref={ref} disablePadding {...props} />);

const tokenListItemRender = ({ data, index, style }) => {
  const { items, selectedItem, onClick } = data;

  return (
    <ListItem key={items[index].id} style={style} selected={items[index].id === selectedItem?.id} onClick={() => onClick(items[index])}>
      <ListItemButton>
        <ListItemAvatar>
          <Avatar>
            <KeyRounded />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={items[index].name} />
      </ListItemButton>
    </ListItem>
  );
};

export default TokenList;
